<template>
  <SimpleDataWithVariation
    :title="title"
    :item-id="itemId"
    :value="value"
    :variation="variation"
    :raw-variation="rawVariation"
    :request-status="requestStatus"
    :comparation-value="comparationValue"
    v-bind="$attrs"
    @reload="getData"
  />
</template>

<script>
import SimpleDataWithVariation from '@/components/cards/models/SimpleDataWithVariation';
import { mapActions } from 'vuex';
import EventBus from '@/utils/event-bus';
import proprietaryModel from '@/mixins/proprietary-model';
import { OPERATION, POST_FIELDS } from '@/services/charts-service';

export default {
  name: 'PropTotalRecontactedUsers',
  components: {
    SimpleDataWithVariation,
  },
  mixins: [
    proprietaryModel,
  ],
  props: {
    title: {
      type: String,
      required: true,
    },
    itemId: {
      type: [String, Number],
      required: true,
    },
  },
  data() {
    return {
      requestStatus: 'loading',
      value: '',
      variation: '',
      rawVariation: '',
      comparationValue: '',
    };
  },
  created() {
    this.getData();
  },
  methods: {
    ...mapActions('cards', [
      'getChartsService',
    ]),
    getData(options) {
      if (!options?.silentRefresh) {
        this.requestStatus = 'loading';
      }

      const reduceFunction = points => points[0].data.reduce((sum, value) => {
        return value > 1 ? sum + 1 : sum;
      }, 0);

      this.getChartsService({
        itemId: this.itemId,
        method: 'getMetricWithVariation',
        params: {
          grouping: [POST_FIELDS.USER_ID, POST_FIELDS.CHANNEL],
          operatiors: OPERATION.COUNT,
          reduceFunction,
        },
      })
        .then(({ collected_mentions, collected_mentions_variation, collected_previous_mentions }) => {
          this.value = collected_mentions;
          this.variation = collected_mentions_variation;
          this.rawVariation = collected_mentions_variation;
          this.comparationValue = collected_previous_mentions;
          this.requestStatus = 'success';

          if (options?.silentRefresh) {
            EventBus.$emit('updated', { itemId: this.itemId });
          }
        })
        .catch(() => {
          this.requestStatus = 'error';
        });
    },
  },
};
</script>
